<template>
  <div class="card assets-offline-map-detail">

    <header class="card-header has-background-light">

      <p class="card-header-title has-text-dark">ASSET DETAILS</p>

      <div class="buttons">

        <b-button
          :type="{ 'is-warning': asset.hotspot }"
          size="is-small"
          :loading="toggling"
          :disabled="!modifiable"
          @click="toggleHotspot"
          >HOTSPOT</b-button
        >

        <b-button
          :type="{ 'is-success': isArchived }"
          size="is-small"
          :loading="archiving"
          :disabled="!modifiable"
          @click="toggleArchive"
        >
          {{ isArchived ? 'RESTORE' : 'ARCHIVE' }}
        </b-button>

        <slot name="headerButtons" :close="close">
            <b-button size="is-small" @click="close('summary')">CLOSE</b-button>
        </slot>

      </div>

    </header>

    <div class="card-content scrollable" :style="{ height: `${height}px` }">

      <table class="table is-fullwidth" ref="main">
        <tbody>
          <tr>
            <th>Asset Code</th>
            <td class="asset-id">{{ asset.thirdPartyCode || asset.id }}</td>
          </tr>
          <tr>
            <th>Asset Type</th>
            <td>{{ asset.code ? `${asset.code.code} - ${asset.code.name}` : "" }}</td>
          </tr>
          <tr>
            <th>Asset Name</th>
            <td>{{ asset.assetName }}</td>
          </tr>
          <tr>
            <th colspan="2" style="height:8rem;">Description</th>
          </tr>
          <tr v-if="asset.comment">
            <td colspan="2">{{ asset.comment.content }}</td>
          </tr>
          <tr>
            <th colspan="2" class="has-background-light has-text-centered">DATA</th>
          </tr>
        </tbody>
      </table>

      <div class="scrollable" :style="`height: ${tagsHeight}px`">
        <table class="table is-fullwidth">
          <tbody>
            <tr v-for="tag in tags" :key="tag.key">
              <th>{{ tag.key }}</th>
              <td>{{ tag.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import { AssetService } from "@/services/asset.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    mapHeight: {
      type: Number,
      default: 500
    },
    asset: {
      type: Object
    },
    modifiable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    assetService: AssetService,
    tagsHeight: 0,
    archiving: false,
    toggling: false
  }),
  computed: {
    isArchived() {
      return this.asset.status.toLowerCase() == "inactive";
    },
    height() {
      return this.mapHeight - 36; // Card header height, Card footer height
    },
    tags() {
      if (this.asset && this.asset.tags) {
        const tags = JSON.parse(this.asset.tags);

        return Object.keys(tags).map(key => {
          return {
            key: key,
            value: tags[key]
          };
        });
      }

      return [];
    }
  },
  mounted() {
    this.setTagsHeight();
  },
  watch: {
    asset: {
      handler() {
        this.setTagsHeight();
      },
      deep: true
    }
  },
  methods: {
    setTagsHeight() {
      this.$nextTick(() => {
        // panel height - main height
        this.tagsHeight = this.height - this.$refs.main.clientHeight;
      });
    },
    async toggleArchive() {
      this.archiving = true;

      let asset = null;

      if (this.isArchived) {
        asset = await this.assetService
          .restore(this.asset.id)
          .then(response => JsonDenormalizer.denormalize(response));
      } else {
        asset = await this.assetService
          .archive(this.asset.id)
          .then(response => JsonDenormalizer.denormalize(response));
      }

      this.asset.status = asset.status;
      this.$store.commit("AssetsMap/UPDATE_ASSET", {
        id: this.asset.id,
        data: asset
      });

      this.$emit("archive");
      this.archiving = false;
    },
    async toggleHotspot() {
      this.toggling = true;

      const asset = await this.assetService
        .toggleHotspot(this.asset.id)
        .then(response => JsonDenormalizer.denormalize(response));

      this.asset.hotspot = asset.hotspot;
      this.$store.commit("AssetsMap/UPDATE_ASSET", {
        id: this.asset.id,
        data: asset
      });

      this.toggling = false;
    },
    close(mode = null) {
      this.$emit('close', mode);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-content {
  .table th {
    word-break: break-all;
  }
  .table:not(:last-child) {
    margin-bottom: 0;
  }
}
.scrollable {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapDetail.vue